// extracted by mini-css-extract-plugin
module.exports = {"container":"ExternalLink_container__hyPrF","disabled":"ExternalLink_disabled___4oCS","icon_container":"ExternalLink_icon_container__3epCL"};